import { createSlice } from "@reduxjs/toolkit";
import axios from "../app/axios";

export const classesSlice = createSlice({
  name: "classesSlice",
  initialState: {
    classData: [],
    terms: [],
    attendance: [],
    classRoster: [],
    studentList: [],
    studentclassData: [],
    errorMessage: undefined,
    dataFetchingStatus: false,
    errorStatusCode: undefined,
  },

  reducers: {
    setclassData: (state, action) => {
      state.classData = action.payload;
    },
    setStudentclassData: (state, action) => {
      state.studentclassData = action.payload;
    },
    setStudentListData: (state, action) => {
      state.studentList = action.payload;
    },
    setTermsData: (state, action) => {
      state.terms = action.payload;
    },
    setAttendanceData: (state, action) => {
      state.attendance = action.payload;
    },
    setClassRosterData: (state, action) => {
      state.classRoster = action.payload;
    },
    removeAttedanceData: (state, action) => {
      state.attendance = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setErrorStatusCode: (state, action) => {
      state.errorStatusCode = action.payload;
    },
    setDataFetchingStatus: (state, action) => {
      state.dataFetchingStatus = action.payload;
    },
    removeElementsFromArray: (state, action) => {
      state.classData = action.payload;
    },
  },
});

export const {
  setclassData,
  setStudentListData,
  setStudentclassData,
  setErrorMessage,
  setErrorStatusCode,
  setDataFetchingStatus,
  removeElementsFromArray,
  setTermsData,
  setAttendanceData,
  setClassRosterData,
  removeAttedanceData,
} = classesSlice.actions;

export const getClassData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`class/classes/${data}`)
    .then((response) => {
      console.log("data...",response)
      dispatch(setDataFetchingStatus(false));
      dispatch(setclassData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getStudentClassData = (studentId) => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`parent/grades/classes/${studentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setStudentclassData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setStudentclassData([]));
      dispatch(setErrorMessage(error.response.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getFacultyClassData = (data) => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`class/facultyclasses/${data}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setclassData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getStudentList = (parentId) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/getStudentList/${parentId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setStudentListData(response.data.studentList));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getAttendanceData = ({classId, studentId}) => (dispatch) => {
  dispatch(removeAttedanceData([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/class/attendance/${classId}`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setAttendanceData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const getClassRosterData = (classId) => (dispatch) => {
  console.log("classId:", classId);
  dispatch(removeAttedanceData([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`/faculty/classroster/${classId.classId}`)
    .then((response) => {
      console.log("Slice response", response)
      dispatch(setDataFetchingStatus(false));
      dispatch(setClassRosterData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.message));
      // dispatch(setErrorStatusCode(error.response.status));
    });
};

export const updateParmsForClass = (data) => (dispatch) => {
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .post(`class/update`, data)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(response.data.message));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};
export const getTermData = () => (dispatch) => {
  dispatch(removeElementsFromArray([]));
  dispatch(setDataFetchingStatus(true));
  axios.defaults.headers.common["Authorization"] =
    "Bearer " + window.localStorage.getItem("x-auth-token");
  axios
    .get(`class/classes/getTerms`)
    .then((response) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setTermsData(response.data));
    })
    .catch((error) => {
      dispatch(setDataFetchingStatus(false));
      dispatch(setErrorMessage(error.response.data.error));
      dispatch(setErrorStatusCode(error.response.status));
    });
};

export const clearClassData = () => (dispatch) => {
  dispatch(removeElementsFromArray([]));
};

export const clearErrorStatusCode = () => (dispatch) => {
  dispatch(setErrorStatusCode(undefined));
};
export const clearErrorMessage = () => (dispatch) => {
  dispatch(setErrorMessage(undefined));
};

export default classesSlice.reducer;
